import { Injectable,Inject,HostListener } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DOCUMENT } from "@angular/common";
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/concat';
import 'rxjs/add/operator/catch';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class I1 implements HttpInterceptor {
  userActivity;

    userInactive: Subject<any> = new Subject();
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
   

    return next.handle(req)
      .retryWhen(error => {
        return error
          .flatMap((err) => {

            if (err instanceof HttpErrorResponse && err.status === 504) { // timeout

              return Observable.of(err.status).delay(5000);
            }

            return Observable.throw({ error: 'No retry' });
          })
          .take(1)
          //.concat(next.handle(req));
        .concat(Observable.throw({ error: 'Sorry, there was an error (after 1 retries)' }));

      });
  }
}

@Injectable()
export class I2 implements HttpInterceptor {
  userActivity;
  sessionVar:boolean=false;
    userInactive: Subject<any> = new Subject();
  private toasterService: ToastrService;
  //appComponent: any;
  sessionTime=1;
  constructor( public router : Router,@Inject(DOCUMENT) private document: any,toasterService:ToastrService,public loaderService: LoaderService) {
    this.toasterService=toasterService;
   }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  
    this.loaderService.show();
    const that=this;
    if (sessionStorage.getItem('currentUser')) {
      setInterval(function(){ 
   
        that.sessionTime=Number(that.sessionTime+1);
        
        if(that.sessionTime>=500000){
          that.sessionCall();
      } }, 1000);
  
     }else{
      //  clearInterval();
      this.sessionVar=true;
      this.sessionTime=100;
     }
    let ok:string;
    const authReq = req.clone({ headers: req.headers.set("headerName", "headerValue")});
    return next.handle(req).do(
      (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
           
            const that=this;
            that.sessionTime=1;
           
    if (sessionStorage.getItem('currentUser')) {
      setInterval(function(){ 
     
        that.sessionTime=Number(that.sessionTime+1);
        
        if(that.sessionTime>=500000){
          that.sessionCall();
      } }, 1000);
  
     }else{
      //  clearInterval();
      this.sessionVar=true;
      this.sessionTime=1;
     }

            let body =event.body;
            let url1=location.origin +'srvcharge/save';
            let url2 = location.origin +'/api/timeSlot';
            console.log('url2', url2);
            
          if(event.headers.get('auth-token') != undefined){
            let newToken = event.headers.get('auth-token');
            let sessionchange = JSON.parse(sessionStorage.getItem('currentUser'))
            sessionchange["Auth-token"] = newToken;
            sessionStorage.setItem('currentUser',JSON.stringify(sessionchange));
          }

         if(body.success===false){
          this.loaderService.hide();
          console.log('event.url', event.url);
          
           if(body.message!='COMMON.ERROR' && event.url != url1 && event.url!=url2){
            this.toasterService.error(body.message);
           }
           
          }else{
            this.loaderService.hide();
            // setTimeout(function(){this.loaderService.hide();}.bind(this),18000);
            // this.toasterService.success('Success', body.message);
          }
              return event;
          }
      },
      (err) => {
          if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.toasterService.error("Access Denied!")
                sessionStorage.clear();
                  this.document.location.href =
                  `${this.document.location.protocol}//${this.document.location.hostname}:${this.document.location.port}/login`;
              }
          }
      });
  }
  
  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), this.sessionTime);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  sessionCall(){
    this.setTimeout();
    this.userInactive.subscribe(() => {
      if (sessionStorage.getItem('currentUser')) {
      sessionStorage.clear();
      if(this.sessionVar){
        this.toasterService.info("Your session is end")
      }
      this.sessionTime=0;
      this.sessionVar=false;
      //clearInterval();
      this.router.navigateByUrl('/login');
    }
  });
  }

}



// WEBPACK FOOTER //
// ./src/app/Http-Interceptor.ts